import { TimerCheckIcon } from './TimerCheckIcon';

/**
 * author: Colton Wiscombe
 * id C9193A95-3EFC-420B-A97A-2B688BE03647
 * name timer-check
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-check.svg
 * tags
 * - Date / Time 
 */
export const StopwatchCheckIcon = TimerCheckIcon;
export default StopwatchCheckIcon